import { ConfigProvider } from 'antd';

function AntdConfigProvider({ children }) {
    return (
        <ConfigProvider
            wave={{ disabled: true }}
            theme={{
                token: {
                    fontFamily: 'font-favorit, sans-serif',
                },
                components: {
                    Table: {
                        rowHoverBg: '#f5f5f5',
                        headerBorderRadius: '0px',
                        headerColor: 'var(--primary-color1)',
                        headerBg: 'transparent',
                        cellPaddingBlock: '16px',
                        cellPaddingInline: '4px',
                        cellBorderRadius: '0px',
                        cellBg: 'transparent',
                        borderColor: '#9CA3AF33',
                        cellFontSize: '16px',
                    },
                },
            }}>
            {children}
        </ConfigProvider>
    );
}

export default AntdConfigProvider;
